import React from "react";
import { useTranslation } from "react-i18next";
import TopBar from '../../components/TopBar'
import Footer from '../../components/Footer'
import { Fade, Slide } from "react-awesome-reveal";
import { isMobileDevice } from "../../utils";
import { useNavigate } from "react-router";
import More from "./components/more"

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  return (
    <div className="">
      <TopBar />
      <div className="relative"
        style={{
          backgroundImage: `url(${require("../../assets/image/icon15.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }} >
        <div className="text-[#181512] text-[45px] py-[118px] font-[700] w-[955px] mx-auto 
        h5:text-center h5:text-[30px] h5:w-full h5:py-[68px] relative z-10">歷史和歷程碑</div>

        <div className="absolute top-0 left-[6px] right-0 bottom-0"
          style={{
            background: 'linear-gradient(to right, #fbfbfbc2, transparent)',
            bottom: '0',
            content: "",
            left: '0',
            pointerEvents: 'auto',
            position: 'absolute',
            right: '0',
            top: '0',
            zIndex: 1
          }}></div>
      </div>

      <div className="w-[1200px] mx-auto pb-[75px] h5:block h5:w-full">
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">1974</div>
                <div className="text-[#181512] text-[24px] font-bold">品牌緣起</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">詩肯柚木創辦人兼董事經理林褔勤先生在新加坡一間只有400平方英呎的辦公室開業。當時公司名為夏威夷室內設計。在短短兩年內，公司便添加了兩間展銷室。</div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-1974.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-1979.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">1979</div>
                <div className="text-[#181512] text-[24px] font-bold">夏威夷家具(私人)有限公司成立</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">夏威夷家具公司成立，主要業務是進出口和銷售家具。連續五年，公司每年營業額達1000萬新幣。</div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>

        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">1988</div>
                <div className="text-[#181512] text-[24px] font-bold">詩肯柚木品牌成立</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">詩肯柚木成立，提供高品質兼具設計感的優質柚木家具，滿足重視生活且眼光獨具的顧客需求。</div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-1988.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2001.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2001</div>
                <div className="text-[#181512] text-[24px] font-bold">獲獎殊榮</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">詩肯柚木首次獲頒新加坡潛質品牌獎項</div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>

        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2003</div>
                <div className="text-[#181512] text-[24px] font-bold">獲獎殊榮</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">詩肯柚木再次獲頒新加坡潛質品牌獎項</div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2003.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2004.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2004</div>
                <div className="text-[#181512] text-[24px] font-bold">進軍日本及德國</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在新加坡開設面積達3萬6000平方英呎的巨型展銷會場 <br />
                  2.在台灣開設25間展銷室 <br />
                  3.進軍日本大阪，開設3間展銷室 <br />
                  4.在德國設立企業辦事處 <br /></div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2005</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在台灣開設第1家旗艦店 <br />
                  2.全台灣設立35家展銷室
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2005.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2005-1.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2005</div>
                <div className="text-[#181512] text-[24px] font-bold">獲獎殊榮</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  詩肯柚木獲頒新加坡潛質品牌獎之『最佳傑出品牌獎』<br /></div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2006</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在台灣開設第1家旗艦店
                  <br />
                  2.全台灣設立40家展銷室
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2006.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2006-1.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2006</div>
                <div className="text-[#181512] text-[24px] font-bold">獲獎殊榮</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  獲頒2006年的『城市商業區域品牌獎』- SPBA (新加坡)<br /></div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2008</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  分別在新加坡、台灣以及日本有超過70間的展廳
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2008.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2006-1.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2009</div>
                <div className="text-[#181512] text-[24px] font-bold">邁向國際舞台</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在世界各地擁有超過90間展銷室<br />
                  2.首次拓展國際舞台，在加拿大溫哥華開設第1家展銷室</div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2010</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在世界各地擁有超過100個展銷室 <br />
                  2.在日本關東開設2間展銷室（橫濱、東京）。
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2010-1.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2011.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2011</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在新加坡有4個概念店及6個展示間
                  <br />
                  2.詩肯柚木在日本推出第一個行動工作室</div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2012</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在美國設立企業辦事處 <br />
                  2.開設第1家SCANTEAK Signature 選品概念店 <br />
                  3.成立『詩肯居家SCANLIVNG』全新品牌
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2012.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2013.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2013</div>
                <div className="text-[#181512] text-[24px] font-bold">獲獎殊榮</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.詩肯柚木獲頒《新加坡Tatler》雜誌『2013 新加坡最佳現代家具獎』
                  <br />
                  2.獲頒2013年的『城市商業區域品牌獎』滿貫獎項 – SPBA (新加坡)
                  <br />
                  3.同時被評選為最受歡迎的地區品牌及家具類別之總冠軍。</div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2014</div>
                <div className="text-[#181512] text-[24px] font-bold">獲獎殊榮</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  詩肯柚木獲頒《新加坡Tatler》雜誌『2014 新加坡最佳現代家具獎』
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2014.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2015.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2015</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在台灣百店達標，進軍台灣東部於花蓮設立最大雙品牌旗艦店
                  <br />
                  2.獨家代理德國nolte GROUP旗下家具品牌</div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2016</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在日本名古屋開設展銷室 <br />
                  2.成立全新專業德國原裝寢具床墊『睡眠精品Sleep Gallery』品牌
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2016.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2017</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在新加坡開設一家快閃店 <br />
                  2.在新加坡設立一個新的展銷室。
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2004.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2019-1.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2019</div>
                <div className="text-[#181512] text-[24px] font-bold">企業發展</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  1.在世界各地擁有超過150間展銷室 <br />
                  2.在新加坡實里達購物中心開設陳列室 <br />
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">2019</div>
                <div className="text-[#181512] text-[24px] font-bold">獲獎殊榮</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  Nest系列榮獲『新加坡優秀設計獎』
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2019-2.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/history/timeline-2019-3.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">2019</div>
                <div className="text-[#181512] text-[24px] font-bold">設計師系列家具</div>
                <div className="text-[#595959] text-[18px] mt-[30px]">
                  推出第三個與NAFA學生合作之Nest系列家具<br />
                </div>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
      </div>

      <More />

      <Footer />
    </div>
  );
};

export default ComponentName;
